import React from 'react';
import { Outlet } from 'react-router-dom';

const IntroRoutes = () => (<Outlet />);

export default IntroRoutes;
